export default __webpack_public_path__ + "static/media/ikara-web.b94ad18e.png";